export default {
  tab: {
    'rendering-engine': 'Silnik renderowania',
    'barcode-scanner': 'Skaner kodów kreskowych',
    'api-explorer': 'Eksplorator API',
  },
};
